<template>
  <div class="wollaston-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>分束角 ≈ 2·(ne - no)·tan(α)</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Unpolarized Light -->
          <line x1="20" y1="120" x2="160" y2="120" stroke="#fff" stroke-width="6" opacity="0.4" />
          <text x="20" y="105" fill="#fff" font-size="8">自然光</text>

          <!-- The Prism (Two Calcite Prisms glued) -->
          <g transform="translate(160, 60)">
             <path d="M 0,0 L 80,0 L 0,120 Z" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" />
             <path d="M 80,0 L 80,120 L 0,120 Z" fill="rgba(0, 210, 255, 0.2)" stroke="#00d2ff" />
             <text x="5" y="115" fill="#00d2ff" font-size="8">方解石 A</text>
             <text x="45" y="10" fill="#00d2ff" font-size="8">方解石 B</text>
          </g>

          <!-- Diverging Polarized Beams -->
          <!-- O-ray (Ordinary) -->
          <line x1="240" y1="120" x2="380" y2="150" stroke="#ff4757" stroke-width="3" />
          <text x="320" y="165" fill="#ff4757" font-size="8">O 光 (横向偏振)</text>

          <!-- E-ray (Extraordinary) -->
          <line x1="240" y1="120" x2="380" y2="90" stroke="#2ed573" stroke-width="3" />
          <text x="320" y="85" fill="#2ed573" font-size="8">E 光 (垂直偏振)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>分束特性：产生两个大角度分离的正交偏振光</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>沃拉斯顿棱镜由两块直角三角形的方解石棱镜粘合而成，且两者的**光轴**相互垂直。当自然光进入第一块棱镜时分解为 O 光和 E 光，进入第二块棱镜时，由于光轴变化，原来的 O 光变为 E 光（反之亦然）。由于两块棱镜对不同偏振光的折射率互换，导致两束光在界面处发生反向偏折，从而将光束分为两束振动方向互相垂直的正交偏振光。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'WollastonPrismViz'
}
</script>

<style scoped lang="scss">
.wollaston-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
